//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { UsesAuthenticatedUser } from '@/mixins'

export default {
  mixins: [ UsesAuthenticatedUser ],

  props: {
    showDarkHeader: Boolean,
  },

  data: () => ({
    features: [
      {
        id: 'featureVideo',
        path: '/features/video-meetings',
        title: 'video meetings',
        description: 'Instant or scheduled meetings',
      },
      {
        id: 'featureCal',
        path: '/features/calendar-and-bookings',
        title: 'calendar and bookings',
        description: 'Integrate Kintell into your busy schedule',
      },
      {
        id: 'featurePay',
        path: '/features/payment-integration',
        title: 'payment integration',
        description: 'Get paid easily for your knowledge',
      },
      {
        id: 'featureKCards',
        path: '/features/kintell-cards',
        title: 'kintell cards',
        description: 'Use “Kintell Cards” to get booked for a video session',
      },
    ],
  }),
  computed: {
    isOnFeatures () {
      return this.$route.path.includes('/features')
    },
  }
}
